import api from './api';

export default {
    async getTranscoderSettings(token) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get('/transcoder', {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao buscar configurações do transcoder:', error);
            throw error;
        }
    }
}
